export const flexCell = () => ({
  item: { flex: 1 },
});
export const normalText = () => ({ levelText: { fontWeight: 'normal' } });
